import ReactGA from 'react-ga4';

// Initialize Google Analytics (ONLY if Measurement ID exists)
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const environment = process.env.REACT_APP_ENV;
  
  // Only initialize in production with valid ID
  if (environment === 'production' && measurementId && measurementId !== '') {
    ReactGA.initialize(measurementId);
    console.log('✅ Google Analytics initialized (Production)');
    return true;
  } else {
    console.log('⚠️ Google Analytics disabled (Non-production environment)');
    return false;
  }
};

// Track page views
export const logPageView = () => {
  if (process.env.REACT_APP_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    const path = window.location.pathname + window.location.search;
    ReactGA.send({ hitType: "pageview", page: path });
    console.log('📊 Page view logged:', path);
  }
};

// Track form submissions
export const logFormSubmission = (formName, success = true) => {
  if (process.env.REACT_APP_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category: 'Form',
      action: success ? 'Submit Success' : 'Submit Failed',
      label: formName,
    });
    console.log('📊 Form submission logged:', formName);
  }
};

// Track events
export const logEvent = (category, action, label = '') => {
  if (process.env.REACT_APP_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
    console.log('📊 Event logged:', { category, action, label });
  }
};
